module.exports = __webpack_public_path__ + "static/media/room.c1aab0f4.svg";